import { useState, useEffect } from "react";

const BASE = "https://support.gs-group.fr/api";
const h = () => ({ Authorization: "Bearer " + localStorage.getItem("nexo_token") });

const STATUT_COLORS = {
  planifiee:"#f5a623", pending:"#f5a623",
  en_cours:"#5b6ef8", "in-progress":"#5b6ef8",
  brouillon:"#8899bb",
};
const STATUT_LABELS = {
  planifiee:"Planifié", pending:"Planifié",
  en_cours:"En cours", "in-progress":"En cours",
  brouillon:"Brouillon",
};

export default function SuggestionsGeo({ T, intervention, onSelectInt, onClose }) {
  const [rayon, setRayon] = useState(10);
  const [suggestions, setSuggestions] = useState([]);
  const [loading, setLoading] = useState(false);
  const [coords, setCoords] = useState({ lat: parseFloat(intervention?.map_lat || intervention?.client_lat) || null, lng: parseFloat(intervention?.map_lng || intervention?.client_lng) || null });
  const [ville, setVille] = useState(intervention?.client_ville || "");

  const load = async (lat, lng) => {
    if (!lat || !lng) return;
    setLoading(true);
    const res = await fetch(
      `${BASE}/interventions/suggestions-geo?lat=${lat}&lng=${lng}&rayon_km=${rayon}&exclude_id=${intervention?.id||""}`,
      { headers: h() }
    ).then(r => r.json()).catch(() => []);
    setSuggestions(Array.isArray(res) ? res : []);
    setLoading(false);
  };

  useEffect(() => {
    if (coords.lat && coords.lng) load(coords.lat, coords.lng);
  }, [rayon]);

  // Géocoder une ville si pas de coords
  const geocodeVille = async (v) => {
    if (!v) return;
    setLoading(true);
    try {
      const res = await fetch(`https://nominatim.openstreetmap.org/search?q=${encodeURIComponent(v+", France")}&format=json&limit=1`).then(r=>r.json());
      if (res[0]) {
        const newCoords = { lat: parseFloat(res[0].lat), lng: parseFloat(res[0].lon) };
        setCoords(newCoords);
        load(newCoords.lat, newCoords.lng);
      }
    } catch(e) {}
    setLoading(false);
  };

  // Ma position GPS
  const useMyPosition = () => {
    navigator.geolocation?.getCurrentPosition(pos => {
      const newCoords = { lat: pos.coords.latitude, lng: pos.coords.longitude };
      setCoords(newCoords);
      load(newCoords.lat, newCoords.lng);
    });
  };

  const prio_colors = { urgent:"#ef4444", urgente:"#ef4444", high:"#f5a623", haute:"#f5a623", medium:"#5b6ef8", normale:"#5b6ef8", low:"#22d3a0", basse:"#22d3a0" };

  return (
    <div style={{position:"fixed",inset:0,background:"rgba(8,12,30,0.22)",backdropFilter:"blur(4px)",zIndex:1000,display:"flex",alignItems:"center",justifyContent:"center",padding:20}}>
      <div style={{background:T.card,border:`1px solid ${T.border}`,borderRadius:16,width:620,maxHeight:"88vh",display:"flex",flexDirection:"column"}}>

        {/* Header */}
        <div style={{padding:"20px 24px 14px",borderBottom:`1px solid ${T.border}`,flexShrink:0}}>
          <div style={{display:"flex",justifyContent:"space-between",alignItems:"flex-start"}}>
            <div>
              <div style={{fontSize:18,fontWeight:800,color:T.text}}>📍 Interventions à proximité</div>
              {intervention && (
                <div style={{fontSize:12,color:T.muted,marginTop:3}}>
                  Depuis : <strong style={{color:T.text}}>{intervention.titre}</strong> · {intervention.client_ville||"—"}
                </div>
              )}
            </div>
            <button onClick={onClose} style={{background:"none",border:"none",color:T.muted,cursor:"pointer",fontSize:22}}>✕</button>
          </div>

          {/* Contrôles */}
          <div style={{display:"flex",gap:10,marginTop:14,flexWrap:"wrap",alignItems:"center"}}>
            {/* Rayon */}
            <div style={{display:"flex",background:T.bg,border:`1px solid ${T.border}`,borderRadius:10,overflow:"hidden"}}>
              {[5,10,20,50].map(r=>(
                <button key={r} onClick={()=>setRayon(r)}
                  style={{padding:"7px 12px",background:rayon===r?T.accentDim:"transparent",border:"none",color:rayon===r?T.accent:T.muted,fontSize:13,fontWeight:rayon===r?700:500,cursor:"pointer"}}>
                  {r} km
                </button>
              ))}
            </div>

            {/* Recherche ville */}
            <div style={{display:"flex",gap:6,flex:1}}>
              <input value={ville} onChange={e=>setVille(e.target.value)}
                onKeyDown={e=>e.key==="Enter"&&geocodeVille(ville)}
                placeholder="Autre ville..."
                style={{flex:1,background:T.bg,border:`1px solid ${T.border}`,borderRadius:10,padding:"7px 12px",color:T.text,fontSize:13,outline:"none"}}/>
              <button onClick={()=>geocodeVille(ville)}
                style={{padding:"7px 12px",borderRadius:9,background:T.accentDim,border:`1px solid ${T.accent}40`,color:T.accent,fontSize:13,fontWeight:600,cursor:"pointer"}}>
                🔍
              </button>
            </div>

            {/* Ma position */}
            <button onClick={useMyPosition}
              style={{padding:"7px 12px",borderRadius:9,background:T.successDim||T.accentDim,border:`1px solid ${T.success}40`,color:T.success,fontSize:13,fontWeight:600,cursor:"pointer",whiteSpace:"nowrap"}}>
              📡 Ma position
            </button>
          </div>

          {/* Coords actives */}
          {coords.lat && (
            <div style={{marginTop:8,fontSize:11,color:T.muted}}>
              📍 Centre : {coords.lat ? parseFloat(coords.lat).toFixed(4) : "—"}, {coords.lng ? parseFloat(coords.lng).toFixed(4) : "—"} · Rayon : {rayon} km
            </div>
          )}
        </div>

        {/* Résultats */}
        <div style={{flex:1,overflowY:"auto",padding:"14px 24px"}}>
          {!coords.lat && (
            <div style={{textAlign:"center",padding:40,color:T.muted}}>
              <div style={{fontSize:48,marginBottom:12}}>📍</div>
              <div style={{fontSize:15,fontWeight:700,color:T.text,marginBottom:6}}>Choisissez un point de départ</div>
              <div style={{fontSize:13}}>Entrez une ville ou utilisez votre position GPS</div>
              <button onClick={useMyPosition} style={{marginTop:16,padding:"10px 20px",borderRadius:10,background:T.accent,border:"none",color:"#fff",fontSize:14,fontWeight:700,cursor:"pointer"}}>
                📡 Utiliser ma position
              </button>
            </div>
          )}

          {loading && (
            <div style={{textAlign:"center",padding:40,color:T.muted}}>
              <div style={{fontSize:32,marginBottom:8}}>⏳</div>
              Recherche en cours...
            </div>
          )}

          {!loading && coords.lat && suggestions.length === 0 && (
            <div style={{textAlign:"center",padding:40,color:T.muted}}>
              <div style={{fontSize:48,marginBottom:12}}>🎯</div>
              <div style={{fontSize:15,fontWeight:700,color:T.text,marginBottom:6}}>Aucune intervention dans ce rayon</div>
              <div style={{fontSize:13}}>Essayez d'augmenter le rayon de recherche</div>
            </div>
          )}

          {!loading && suggestions.length > 0 && (
            <div style={{display:"flex",flexDirection:"column",gap:10}}>
              <div style={{fontSize:13,fontWeight:600,color:T.muted,marginBottom:4}}>
                {suggestions.length} intervention(s) trouvée(s) dans un rayon de {rayon} km
              </div>
              {suggestions.map((s,idx)=>{
                const sc = STATUT_COLORS[s.statut] || T.muted;
                const pc = prio_colors[s.priorite] || T.muted;
                const dist = parseFloat(s.distance_km);
                const distColor = dist<=2?"#22d3a0":dist<=5?"#f5a623":"#5b6ef8";
                return (
                  <div key={s.id}
                    onClick={()=>{ onSelectInt&&onSelectInt(s); onClose(); }}
                    style={{background:T.bg,border:`1px solid ${T.border}`,borderRadius:13,padding:"14px 16px",cursor:"pointer",transition:"all 0.15s",display:"flex",gap:14,alignItems:"flex-start"}}
                    onMouseEnter={e=>{ e.currentTarget.style.borderColor=T.accent; e.currentTarget.style.background=T.accentDim; }}
                    onMouseLeave={e=>{ e.currentTarget.style.borderColor=T.border; e.currentTarget.style.background=T.bg; }}>

                    {/* Distance badge */}
                    <div style={{flexShrink:0,textAlign:"center",minWidth:60}}>
                      <div style={{fontSize:20,fontWeight:800,color:distColor}}>{dist}</div>
                      <div style={{fontSize:10,color:T.muted,fontWeight:600}}>km</div>
                      <div style={{width:40,height:3,background:T.border,borderRadius:2,margin:"4px auto"}}>
                        <div style={{height:"100%",borderRadius:2,background:distColor,width:`${Math.max(10,100-dist*5)}%`}}/>
                      </div>
                    </div>

                    <div style={{flex:1,minWidth:0}}>
                      {/* Titre + badges */}
                      <div style={{display:"flex",alignItems:"center",gap:8,marginBottom:6,flexWrap:"wrap"}}>
                        <span style={{fontSize:14,fontWeight:700,color:T.text,overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}}>{s.titre}</span>
                        <span style={{fontSize:10,fontWeight:700,color:sc,background:sc+"22",padding:"2px 8px",borderRadius:20,textTransform:"uppercase",flexShrink:0}}>{STATUT_LABELS[s.statut]||s.statut}</span>
                        <span style={{fontSize:10,fontWeight:700,color:pc,background:pc+"22",padding:"2px 8px",borderRadius:20,flexShrink:0}}>{s.priorite}</span>
                      </div>

                      {/* Infos */}
                      <div style={{fontSize:12,color:T.muted,display:"flex",gap:12,flexWrap:"wrap"}}>
                        <span>👤 {s.client_nom||"—"}</span>
                        <span>📍 {s.client_adresse||""} {s.client_ville||""}</span>
                      </div>

                      {/* Technicien + date */}
                      <div style={{display:"flex",gap:12,marginTop:6,fontSize:11,color:T.muted}}>
                        {s.technicien_nom
                          ? <span style={{color:T.accent,fontWeight:600}}>🔧 {s.technicien_nom}</span>
                          : <span style={{color:T.warning,fontWeight:700}}>⚠ Non assigné</span>}
                        {s.date_planifiee && <span>🕐 {new Date(s.date_planifiee).toLocaleDateString("fr-FR")}</span>}
                        {s.client_telephone && <a href={`tel:${s.client_telephone}`} onClick={e=>e.stopPropagation()} style={{color:T.success,fontWeight:600,textDecoration:"none"}}>📞 {s.client_telephone}</a>}
                      </div>

                      {/* Lien Maps */}
                      {s.map_lat && (
                        <div style={{marginTop:8,display:"flex",gap:8}}>
                          <a href={`https://www.google.com/maps/search/?api=1&query=${s.map_lat},${s.map_lng}`}
                            target="_blank" rel="noreferrer" onClick={e=>e.stopPropagation()}
                            style={{padding:"4px 10px",borderRadius:7,background:"#4285f422",border:"1px solid #4285f440",color:"#4285f4",fontSize:11,fontWeight:700,textDecoration:"none"}}>
                            📍 Google Maps
                          </a>
                          <a href={`https://waze.com/ul?ll=${s.map_lat},${s.map_lng}&navigate=yes`}
                            target="_blank" rel="noreferrer" onClick={e=>e.stopPropagation()}
                            style={{padding:"4px 10px",borderRadius:7,background:"#33ccff22",border:"1px solid #33ccff40",color:"#33ccff",fontSize:11,fontWeight:700,textDecoration:"none"}}>
                            🚗 Waze
                          </a>
                        </div>
                      )}
                    </div>
                  </div>
                );
              })}
            </div>
          )}
        </div>

        {/* Footer */}
        <div style={{padding:"12px 24px",borderTop:`1px solid ${T.border}`,flexShrink:0,display:"flex",justifyContent:"space-between",alignItems:"center"}}>
          <div style={{fontSize:11,color:T.muted}}>
            💡 Cliquez sur une intervention pour l'ouvrir · Optimisez les tournées de vos techniciens
          </div>
          <button onClick={onClose} style={{padding:"8px 16px",borderRadius:9,border:`1px solid ${T.border}`,background:"transparent",color:T.muted,fontSize:13,cursor:"pointer"}}>Fermer</button>
        </div>
      </div>
    </div>
  );
}
